import React from 'react';
import { Link } from 'react-router-dom';
import CustomButton from '../../../../commons/custom-button/custom-button.component';

import './reset-failed.styles.scss';
import PrimaryCustomButton from '../../../../commons/primary-custom-button/primary-custom-button.component';

function ResetFailed() {
  return (
    <div className="reset-failed module-spacer">
      <div className="form-container background action-item">
        <h2>Password Reset Failed</h2>
        <p className="blurb">
          We're sorry, but the link you clicked appears to be invalid.
        </p>

        <Link to="/login">
          <PrimaryCustomButton title={'Continue'}/>
        </Link>
      </div>
    </div>
  );
}

export default ResetFailed;
